// extracted by mini-css-extract-plugin
module.exports =  {"key":"style-module_key__P2HutgQ7hPFSQET6855G","row":"style-module_row___uJsowlhhLagkqsPUGxy"};